import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, } from "react-redux";
import { toggleReload } from "../../../src/taskpane/redux/modules/reload";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Refresh(selectedItems: any[]) {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();
    
    const [menuItem_Refresh, setMenuItem_Refresh] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        setMenuItem_Refresh(
            {
                key: "refresh",
                iconProps: { iconName: "Refresh" },
                iconOnly: true,
                tooltipHostProps: {
                    content: <span>{languageStrings.Refresh}</span>,
                },
                onClick: () => {
                    dispatch(toggleReload());
                }
            }
        )
    }, [selectedItems])

    return {
        menuItem_Refresh
    }

}